import React from 'react';

export function Contacts() {
  return (
    <div style={{ paddingBottom: '2rem' }}>
      <div className="media">
        <div className="media-content has-text-centered">
          <a href="tel:+79059579314">8-905-957-93-14</a> (Telegram, WhatsApp)
        </div>
      </div>
      <div className="media">
        <div className="media-content has-text-centered">
          <a href="mailto:sasha@ferndecor.ru">sasha@ferndecor.ru</a>
        </div>
      </div>
      <div className="media">
        <div className="media-content has-text-centered">
          <a href="https://instagram.com/fern_decor" target="_blank" rel="noopener noreferrer">
            instagram.com/fern_decor
          </a>
        </div>
      </div>
      <div className="media">
        <div className="media-content has-text-centered" target="_blank" rel="noopener noreferrer">
          <a href="https://vk.com/fern_decor">vk.com/fern_decor</a>
        </div>
      </div>
    </div>
  );
}
